/**
 * Reachable without a session. Not lazy — this is the first screen a cold start shows.
 *
 * No `/unlock` route: PIN unlock exists to make repeated logins fast on a shared till, which is a
 * POS problem, not a dashboard one. The dashboard always signs in with a password.
 */

import type { RouteObject } from 'react-router';

import { SignInPage } from '@/pages/SignInPage';

export const publicRoutes: RouteObject[] = [
  { path: 'sign-in', Component: SignInPage, handle: { title: 'Sign in' } },
];
